/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Group, Text } from '@mantine/core';

// Styles
import classes from './Footer.module.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Footer = (props: {
	versionIGLU: string;
	buildIGLU: string;
	versionAPI: string;
	buildAPI: string;
	isStaging: boolean;
}) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<Group className={classes.container}>
			<Text className={classes.version} tt={'capitalize'}>
				IGLU {props.versionIGLU}
			</Text>
			{props.isStaging && props.buildIGLU && (
				<Text className={classes.version}>
					build: {props.buildIGLU}
				</Text>
			)}
			<Text className={classes.version} tt={'capitalize'}>
				|
			</Text>
			<Text className={classes.version} tt={'capitalize'}>
				API {props.versionAPI}
			</Text>
			{props.isStaging && props.buildAPI && (
				<Text className={classes.version}>
					build: {props.buildAPI}
				</Text>
			)}
		</Group>
	);
};
